
// Colors are in order like this...  home: [ inside, outline, outline2, outline3 ]
var font = {
    "0": "M512.609 916.742v-809.483l-107.171-107.258h-298.179l-107.258 107.258v809.483l107.258 107.258h298.179zM305.088 816.444h-97.601v-608.922h97.601z",
    "1": "M296.039 207.521h88.639v-207.521h-384.679v207.521h88.605v551.917h-88.605v157.303l107.258 107.258h188.781z",
    "2": "M405.438 1024l107.258-107.258v-392.161l-107.258-107.258h-197.951v-209.801h97.705v121.022h207.417v-328.544h-512.609v517.603l107.258 107.241h197.934v191.6h-97.705v-102.891h-207.487v203.189l107.258 107.258z",
    "3": "M405.438 1024l107.293-107.258v-350.73l-44.964-44.911 44.964-44.964v-368.896l-107.293-107.241h-298.266l-107.171 107.258v221.285h207.487v-121.022h97.67v209.801h-155.267v207.521h155.267v191.6h-97.67v-102.891h-207.487v203.189l107.171 107.258z",
    "4": "M469.716 270.512v-62.956h88.552v-207.556h-384.557v207.556h88.587v62.956h-157.216l-105.083 168.596 231.221 584.892h238.495v-546.001h88.552v-207.487zM262.212 538.101l-23.717-60.102h23.717z",
    "5": "M0 1024h512.574v-207.556h-305.088v-191.6h197.951l107.223-107.241v-410.345l-107.223-107.258h-298.214l-107.223 107.258v221.285h207.487v-121.022h97.636v209.801h-305.122z",
    "6": "M305.088 772.977v43.502h-97.636v-191.635h197.986l107.258-107.241v-410.345l-107.258-107.258h-298.266l-107.171 107.258v809.483l107.171 107.258h298.266l107.258-107.258v-143.765zM207.452 417.322v-209.801h97.636v209.801z",
    "7": "M0 1024h520.579v-211.384l-216.378-605.094h80.479v-207.521h-384.679v207.521h83.854l217.701 608.922h-93.964v-121.005h-207.591z",
    "8": "M512.609 566.012l-44.929-44.911 44.929-44.964v-368.896l-107.171-107.241h-298.214l-107.223 107.258v368.896l44.929 44.964-44.929 44.894v350.73l107.223 107.258h298.214l107.258-107.258zM305.157 417.322h-97.74v-209.801h97.74zM305.157 816.444h-97.74v-191.6h97.74z",
    "9": "M512.644 916.742v-809.483l-107.206-107.258h-298.214l-107.223 107.258v143.748h207.521v-43.502h97.636v191.687h-197.934l-107.223 107.171v410.38l107.223 107.258h298.214zM305.157 816.444h-97.636v-209.766h97.636z",
    "A": "M438.849 0h-126.163l-36.351 283.46h-113.653l-36.463-283.46h-126.219l131.38 1024h176.033zM260.291 408.557l-40.839 317.735-40.783-317.735z",
    "B": "M383.369 465.608v-383.032l-82.575-82.575h-300.794v1024h300.794l82.575-82.519v-383.145l-46.505-46.28zM258.048 449.395h-132.838v-324.186h132.838zM258.048 898.903h-132.838v-324.298h132.838z",
    "C": "M258.244 283.322v-158.156h-133.021v773.779h133.021v-158.268h125.167v200.85l-82.528 82.472h-218.355l-82.528-82.472v-859l82.528-82.528h218.355l82.528 82.528v200.794h-125.167z",
    "D": "M300.85 1024l82.575-82.519v-858.906l-82.575-82.575h-300.85v1024zM258.048 898.903h-132.894v-773.694h132.894z",
    "E": "M383.257 898.903v125.041h-383.257v-1023.944h383.257v125.209h-258.048v324.186h196.284v125.209h-196.284v324.298h258.048z",
    "F": "M125.209 449.395h196.341v125.209h-196.341v324.298h258.104v125.041h-383.313v-1023.944h125.209v449.395z",
    "G": "M191.741 574.605v-125.209h66.419v-324.186h-132.951v773.582h132.951v-158.138h125.209v200.828l-82.631 82.463h-218.218l-82.519-82.463v-858.962l82.519-82.519h218.218l82.631 82.519v492.085h-191.628z",
    "H": "M258.16 574.605h-132.951v449.339h-125.209v-1023.944h125.209v449.395h132.951v-449.395h125.209v1023.944h-125.209v-449.339z",
    "I": "M0 0h125.097v1024h-125.097v-1024z",
    "J": "M300.794 0l82.631 82.519v941.425h-125.265v-898.735h-133.063v158.138h-125.097v-200.828l82.519-82.519h218.275z",
    "K": "M371.42 1023.944h-135.475l-110.736-267.472v267.472h-125.209v-1023.944h125.209v419.944l115.504-419.944h129.697l-168.741 613.929 169.75 410.015z",
    "L": "M125.335 125.167v898.833h-125.335v-1024h383.355v125.167h-258.020z",
    "M": "M420.505 1023.944l-162.177-535.112-162.177 535.112h-96.151v-1023.944h125.153l0.056 496.573 133.119-439.242 133.119 439.242v-496.573h125.153v1023.944h-96.095z",
    "N": "M258.16 1023.944v-518.395l-133.063 518.395h-125.097v-1023.944h125.097v518.507l133.063-518.507h125.153v1023.944h-125.153z",
    "O": "M300.85 1024l82.575-82.519v-858.906l-82.575-82.575h-218.275l-82.575 82.575v858.906l82.575 82.519zM258.048 898.959h-132.838v-773.75h132.838z",
    "P": "M300.85 1024l82.463-82.519v-448.778l-82.463-82.687h-175.641v-410.015h-125.209v1024zM258.048 898.959h-132.894v-363.847h132.894z",
    "Q": "M357.409 146.458l-76.943-77.204 35.568-69.254h-131.132l-35.673 69.254h-72.34l-76.89 77.204v800.652l76.89 76.89h203.576l76.943-76.89zM116.8 186.21h123.809v721.251h-123.914z",
    "R": "M387.464 0h-128.182l-86.895 410.015h-47.29v-410.015h-125.097v1024h300.794l82.463-82.519v-448.778l-82.463-82.687zM125.097 535.112h132.951v363.847h-132.951z",
    "S": "M82.524 1024l-82.524-82.524v-409.477l82.524-82.58h175.65v-324.148h-132.902v158.091h-125.272v-200.839l82.524-82.524h218.399l82.58 82.524v409.589l-82.58 82.524h-175.65v324.26h132.902v-158.203h125.328v200.783l-82.58 82.524h-218.399z",
    "T": "M418.654 1023.944h-418.654v-125.041h146.694v-898.903h125.209v898.903h146.751v125.041z",
    "U": "M300.978 0l82.411 82.58v941.42h-125.104v-898.784h-133.070v898.784h-125.216v-941.42l82.524-82.58h218.455z",
    "V": "M312.742 1023.944l-93.234-726.179-93.346 726.179h-126.163l131.492-1023.944h175.921l131.38 1023.944h-126.051z",
    "W": "M448.61 1023.944l-46-477.5-52.339 477.5h-126.051l-52.339-477.5-46 477.5h-125.882l98.9-1023.944h139.065l49.31 449.395 49.253-449.395h139.065l98.9 1023.944h-125.882z",
    "X": "M388.137 0l-129.585 523.107 124.087 500.837h-129.024l-59.575-240.489-59.519 240.489h-129.024l124.031-500.837-129.529-523.107h129.024l65.017 262.76 64.961-262.76h129.136z",
    "Y": "M397.954 1023.944h-129.248l-69.841-287.386-69.841 287.386h-129.024l136.429-550.595v-473.349h125.097v473.349l136.429 550.595z",
    "Z": "M383.201 1023.944h-383.201v-125.041h251.596l-251.596-773.694v-125.209h383.201v125.209h-251.652l251.652 773.694v125.041z",
};
var font_size = 26,
    tracking = 4,
    panel_Hor_Adjustment = 2.5,
    font_Top_Adjustment = -16.5,
    middleSpreadAdjustment = {
        left: 1,
        right: 1
    },
    small_Caps_Adjustment = {
        vertical: -215,
        horizontal: 0,
        scale_width: 0, // effects period
        scale_height: 0, // effects period
    },
    colors = {
        characters: {
            home: [
                "#ffb71b", // gold
            ],
            away: [
                "#0a0203", // black
            ],
          third: [
                "#ffb71b", // black
            ]
        },
        numbers: {
            home: [
                "#ffb71b", // gold
                "#FFFFFF", // white
            ],
            away: [
                "#0a0203", // black
                "#ffb71b", // gold

            ],
          third: [
                "#ffb71b", // black
                "#ffffff", // gold

            ]
        }
    },
    outlines = {
        characters: {
            width: 0
        },
        numbers: {
            width: 2.5
        }
    },
    special_Character_Adjustments = {
        period: {
            vertical: 3.5, // this moves it up from the bottom
            horizontal: 3,
            scale_width: 12.5,
            scale_height: 12.5,
        },
        hyphen: {
            vertical: -6,
            horizontal: -5.5,
            scale_width: 0,
            scale_height: -3,
        },
        apostrophe: {
            vertical: 0.25, // this is backwards
            horizontal: -1,
            scale_width: 0,
            scale_height: 0,
        }
    },
    number_Adjustments = {
        top: 18,
        left: -6.5,
        width: 105,
        height: 80,
        middle_Space: 5,
    };
